import { initializeApp } from "firebase/app";

var firebaseConfig = {
  apiKey: "AIzaSyABlmwpotqcQtA-2YC355gil3FTWg9Kl0k",
  authDomain: "chukul.firebaseapp.com",
  databaseURL: "https://chukul-default-rtdb.firebaseio.com",
  projectId: "chukul",
  storageBucket: "chukul.appspot.com",
  messagingSenderId: "1057494296073",
  appId: "1:1057494296073:web:b7dd9a876a1730fe5ffad8",
  measurementId: "G-07ZSKE8PZF",
};

const app = initializeApp(firebaseConfig);

export default app;
